import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorDetail`

export default defineMessages({
  contactInformationTabLabel: {
    id: `${scope}.contactInformationTabLabel`,
    defaultMessage: 'Contact information',
  },
  settingsTabLabel: {
    id: `${scope}.settingsTabLabel`,
    defaultMessage: 'Settings',
  },
  paymentMethodsHeader: {
    id: `${scope}.paymentMethodsHeader`,
    defaultMessage: 'Payment methods',
  },
  paymentMethodsRedirectAlertText: {
    id: `${scope}.paymentMethodsRedirectAlertText`,
    defaultMessage:
      "To keep financial information secure and controlled, payment methods have moved to the <a>Accounts Payable > Manage Payees</a> page. You may need to request permission from your organization's administrator to access this page.",
  },
  addressLabel: {
    id: `${scope}.addressLabel`,
    defaultMessage: 'Address',
  },
  paymentTermsLabel: {
    id: `${scope}.paymentTerms`,
    defaultMessage: 'Payment terms',
  },
  shippingViaLabel: {
    id: `${scope}.shippingVia`,
    defaultMessage: 'Shipping via',
  },
  shippingTermsLabel: {
    id: `${scope}.shippingTerms`,
    defaultMessage: 'Shipping terms',
  },
  phoneLabel: {
    id: `${scope}.phone`,
    defaultMessage: 'Phone',
  },
  phoneTwoLabel: {
    id: `${scope}.phoneTwo`,
    defaultMessage: 'Phone #2',
  },
  faxLabel: {
    id: `${scope}.faxLabel`,
    defaultMessage: 'Fax',
  },
  websiteLabel: {
    id: `${scope}.websiteLabel`,
    defaultMessage: 'Website',
  },
  emailsLabel: {
    id: `${scope}.emailsLabel`,
    defaultMessage: 'Emails',
  },
  vendorIdLabel: {
    id: `${scope}.vendorIdLabel`,
    defaultMessage: 'Vendor ID',
  },
  contactRepNameLabel: {
    id: `${scope}.contactRepNameLabel`,
    defaultMessage: 'Contact rep name',
  },
  vendorCommentLabel: {
    id: `${scope}.vendorCommentLabel`,
    defaultMessage: 'Vendor comment',
  },
  financialTabLabel: {
    id: `${scope}.financialTabLabel`,
    defaultMessage: 'Financial Settings',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Vendor Details',
  },
  errorTitleText: {
    id: `${scope}.errorTitleText`,
    defaultMessage: 'Error',
  },
  errorMessageText: {
    id: `${scope}.errorMessageText`,
    defaultMessage: 'An error has occured while retrieving {type} info',
  },
  preferredLabel: {
    id: `${scope}.preferredLabel`,
    defaultMessage: 'Preferred',
  },
  pendingRequestLabel: {
    id: `${scope}.pendingRequestLabel`,
    defaultMessage: 'Vendor requested',
  },
})
